
import { Icon } from "@iconify/react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function CustomHeader() {
  const router = useNavigate();

  const [showMenu, setshowMenu] = useState(false);
  const arrayBtn = [
    {
      name: "HOME",
      path: "/home",
    },
    {
      name: "ABOUT US",
      path: "/about",
    },
    {
      name: "MUSEUM",
      path: "/museum",
    },
    {
      name: "TEXTILE LAB",
      path: "/textile-lab",
    },
    {
      name: "DESIGN SHOP",
      path: "/design-shop",
    },
    {
      name: "CIRCULAR DESIGN",
      path: "/circular-design",
    },
    {
      name: "KNOWLEDGE",
      path: "/knowledge",
    },
    {
      name: "NEWS & EVENT",
      path: "/blog",
    },
  ];

  return showMenu ? (
    <div className="flex flex-col">
      <div onClick={()=>{
        setshowMenu(!showMenu)
      }} className="md:hidden flex text-3xl cursor-pointer active:opacity-50 self-center">
        <Icon icon={'uis:bars'}  />
      </div>
      {arrayBtn.map((item, i) => {
        return (
          <div
            key={i}
            onClick={() => {
              router(item.path);
              setTimeout(function () {
                document.documentElement.style.scrollBehavior = "smooth";
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
              }, 500);
              
            }}
            className="font_Kanit font-semibold cursor-pointer hover:opacity-80  md:hidden text-center w-full border-b py-3"
          >
            {item.name}
          </div>
        );
      })}
    </div>
  ) : (
    <div className="fixed z-50 p-8 flex flex-row w-full gap-[40px] items-center bg-white">
      <div>
        <img
          src="/img/logo.png"
          className="w-[200px] cursor-pointer hover:opacity-50 object-contain"
        />
      </div>
      <div className="flex-1 "></div>
      {arrayBtn.map((item, i) => {
        return (
          <div
            key={i}
            onClick={() => {
              router(item.path);
              setTimeout(function () {
                document.documentElement.style.scrollBehavior = "smooth";
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
              }, 500);
            }}
            className="font_Kanit font-semibold cursor-pointer hover:opacity-80 hidden md:flex"
          >
            {item.name}
          </div>
        );
      })}
      <div onClick={()=>{
        setshowMenu(!showMenu)
      }} className="md:hidden flex text-3xl cursor-pointer active:opacity-50">
        <Icon icon={'uis:bars'}  />
      </div>
    </div>
  );
}
